<template>
  <div class="recommendation">
    <div class="re-title">
      <img src="../assets/iconfont6.png" />
      热门推荐
    </div>
    <div class="re-list">
      <ul>
        <li v-for="(item,index) in listData" :key="index">
          <img :src="imgSrc(index)" />
          <a @click="topTp(item.tid,item.flog)">{{item.title}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listData: []
    };
  },
  created() {
    this.getWebtop();
  },
  methods: {
    imgSrc: function(index) {
      return "../../static/images/sort-" + index + ".png";
    },
    getWebtop() {
      this.$axios({
        method: "get",
        url: "/zs/webTop/"
      }).then(res => {
        let topData = JSON.parse(res.data).respData;
        this.listData = topData;
      });
    },
    topTp(tid, flog) {
      if (flog == "tbFarmingWiki") {
        this.$router.push({
          path: "/WikiDetails",
          query: {
            tid: tid
          }
        });
      } else if (flog == "tbFarmingCourse") {
        this.$router.push({
          path: "/classroomDetail",
          query: {
            tid: tid
          }
        })
      } else {
        this.$router.push({
          path: "/informationDetail",
          query: {
            tid: tid
          }
        })
      }
    }
  }
};
</script>

<style lang="less">
.recommendation {
  width: 331px;
  //   height: 245px;
  background-color: #fff;
  padding: 10px 15px;
  .re-title {
    font-size: 18px;
    color: #333;
    border-bottom: 1px solid #e4e4e4;
    padding-bottom: 10px;
    img {
      width: 18px;
    }
  }
  .re-list {
    padding-top: 10px;
    li {
      width: 280px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 5px 0;
      cursor: pointer;
      a {
        color: #333;
        &:hover {
          color: #149508;
        }
      }
      img {
        width: 16px;
        margin-right: 5px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/recommendation.vue